import { isPlatformServer } from '@angular/common';
import {
  Injectable,
  Inject,
  Optional,
  inject,
  PLATFORM_ID
} from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { UAParser } from 'ua-parser-js';

@Injectable()
export class SsrRequestService {
  protected _platformId = inject(PLATFORM_ID);

  protected get _isPlatformServer(): boolean {
    return isPlatformServer(this._platformId);
  }

  constructor(@Optional() @Inject(REQUEST) private _request: Request | null) {}

  protected get request(): Request | null {
    return this._request;
  }

  isDesktop(): boolean | null {
    const userAgent = this._isPlatformServer
      ? this._request?.headers['user-agent']
      : navigator.userAgent;
    if (userAgent) {
      const parsedContent = new UAParser(userAgent);
      const deviceType = parsedContent.getDevice().type;
      return !['mobile', 'tablet', 'wearable', 'embedded'].includes(
        deviceType || ''
      );
    }
    return null;
  }
}
